<img *ngIf="userPhoto; else noImageFound"
     [src]="userPhoto"
     [alt]="userInitials">
<ng-template #noImageFound>
    {{ userInitials }}
</ng-template>
